import { createSelector } from "reselect";

import { roundToNearest } from "../budget/selectors";
import { getNodesByIds } from "../core/selectors";

export const getOffer = createSelector(
	[(state) => state.offer],
	(offer) => offer,
);

export const getPlotSelection = createSelector(
	[(state) => state.selection.plot],
	(plot) => plot,
);

export const getBudgetSelection = createSelector(
	[(state) => state],
	(state) => {
		const { budget } = state.selection;
		const { currency, increment } = state.budget.config;
		const { factor } = state.budget.blocker;
		return {
			budget,
			currency,
			increment,
			factor,
		};
	},
);

export const getHouseTypeSelection = createSelector(
	[(state) => state],
	(state) => {
		const selection = state.selection.nodes;

		const getHouseTypeNodes = (ids) => {
			const selectIds = ids.filter((sel) => selection.includes(sel));
			const nodeArr = getNodesByIds({
				state,
				ids: selectIds,
			});
			if (nodeArr.length === 1) {
				return nodeArr[0];
			}
			if (nodeArr.length > 1) {
				return nodeArr;
			}
			return false;
		};

		const houseTypeRoot = state.houseType.rootNode;
		const houseType =
			houseTypeRoot.children && getHouseTypeNodes(houseTypeRoot.children);
		const layout = houseType && getHouseTypeNodes(houseType.children);

		return {
			houseType,
			layout,
		};
	},
);

export const getConfigurationSelection = createSelector(
	[(state) => state],
	(state) => {
		const selection = state.selection.nodes;
		const { area } = state.core;

		const getSelection = (ids) => {
			const selectIds = ids.filter((sel) => selection.includes(sel));
			return getNodesByIds({
				state,
				ids: selectIds,
			});
		};

		const configurationRoot = state.configuration.rootNode;
		const configurationElements =
			configurationRoot.children && getSelection(configurationRoot.children);
		const options = [];
		let price = 0;

		if (configurationElements) {
			for (const element of configurationElements) {
				const option = getSelection(element.children)[0];
				const optionPrice = roundToNearest(
					option.pricePerArea ? option.price * area : option.price,
				);
				options.push({
					...element,
					option: {
						...option,
						price: optionPrice,
					},
				});
				price += optionPrice;
			}
		}

		return {
			selection: options,
			price,
		};
	},
);

export const getOfferForm = createSelector(
	[(state) => state.offer.form],
	(form) => form,
);

export const getClientSelection = createSelector(
	[(state) => state.selection.client],
	(clientSelection) => clientSelection,
);

export const getPrefill = createSelector(
	[(state) => state.offer.prefill],
	(prefill) => prefill,
);



// WEBPACK FOOTER //
// ./src/modules/offer/selectors.js